import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  FaUsers, 
  FaCalendarAlt, 
  FaHandshake, 
  FaHeart, 
  FaChalkboardTeacher,
  FaLanguage,
  FaWhatsapp,
  FaGlobe,
  FaUtensils,
  FaMusic,
  FaFutbol,
  FaPaintBrush,
  FaCheckCircle,
  FaStar,
  FaQuoteLeft,
  FaTrophy,
  FaClock,
  FaMapMarkerAlt,
  FaVideo,
  FaCoffee,
  FaCamera,
  FaBook,
  FaCity,
  FaSmile,
  FaGift,
  FaArrowRight,
  FaRocket,
  FaPhoneAlt,
  FaShieldAlt,
  FaSearch,
  FaRegSmile,
  FaRegHeart,
  FaRegCalendarAlt,
  FaRegClock,
  FaChevronRight,
  FaUniversity,
  FaBuilding,
  FaRegBuilding,
  FaGraduationCap,
  FaChartLine,
  FaSchool,
  FaBriefcase,
  FaGlobeAfrica
} from 'react-icons/fa';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import './IntegrationSociale.css';

const IntegrationSociale = () => {
  const [activeFaq, setActiveFaq] = useState(null);

  const events = [
    {
      id: 1,
      title: "Salon international des Grandes écoles Françaises (SIGEF)",
      subtitle: "Orientation scolaire, poursuite d'études en France et partenariat universitaire",
      date: "13/03/2026",
      location: "HOTEL CRYSTAL PALACE / DOUALA",
      type: "salon",
      description: "Venez rencontrer les représentants des grandes écoles françaises, découvrez les opportunités d'études en France et bénéficiez de conseils personnalisés pour votre orientation scolaire.",
      icon: <FaSchool />,
      attendees: "Places illimitées",
      featured: true,
      status: "past"
    },
    {
      id: 2,
      title: "Salon international des Grandes écoles Françaises (SIGEF)",
      subtitle: "Orientation scolaire, poursuite d'études en France et partenariat universitaire",
      date: "27/02/2026",
      location: "HOTEL PALM CLUB / ABIDJAN COCODY",
      type: "salon",
      description: "Venez rencontrer les représentants des grandes écoles françaises, découvrez les opportunités d'études en France et bénéficiez de conseils personnalisés pour votre orientation scolaire.",
      icon: <FaGlobeAfrica />,
      attendees: "Places illimitées",
      featured: true,
      status: "past"
    }
  ];

  const activities = [
    { name: "Dîners partagés", icon: <FaUtensils />, color: "#e67e22", desc: "Cuisines du monde, partage de recettes" },
    { name: "Soirées à thème", icon: <FaMusic />, color: "#9b59b6", desc: "Musique, danses, costumes" },
    { name: "Tournois sportifs", icon: <FaFutbol />, color: "#2ecc71", desc: "Football, basket, randonnées" },
    { name: "Ateliers créatifs", icon: <FaPaintBrush />, color: "#e74c3c", desc: "Art, photo, écriture" },
    { name: "Ciné-club", icon: <FaVideo />, color: "#3498db", desc: "Films français en VO" },
    { name: "Club photo", icon: <FaCamera />, color: "#f39c12", desc: "Découverte des villes" }
  ];

  const partners = [
    { name: "Société Générale", role: "Banque partenaire", icon: <FaUniversity />, color: "#e31837" },
    { name: "StudaPart", role: "Hébergement étudiant", icon: <FaBuilding />, color: "#2c3e50" },
    { name: "Nexity", role: "Promoteur immobilier", icon: <FaRegBuilding />, color: "#004d73" },
    { name: "Smart Garant", role: "Garantie locative", icon: <FaShieldAlt />, color: "#00a651" },
    { name: "Studely", role: "Accompagnement étudiant", icon: <FaGraduationCap />, color: "#6c5ce7" },
    { name: "Omnes Education", role: "École de commerce", icon: <FaChartLine />, color: "#ff6b6b" }
  ];

  const benefits = [
    { icon: <FaUsers />, title: "Réseau de 5000+ étudiants internationaux", desc: "Une communauté bienveillante et active" },
    { icon: <FaCalendarAlt />, title: "Événements exclusifs chaque semaine", desc: "Plus de 50 événements par an" },
    { icon: <FaHandshake />, title: "Système de parrainage personnalisé", desc: "Un mentor francophone dédié" },
    { icon: <FaChalkboardTeacher />, title: "Accès à des mentors francophones", desc: "Aide linguistique et culturelle" },
    { icon: <FaGlobe />, title: "Découverte culturelle de la France", desc: "Visites et ateliers thématiques" },
    { icon: <FaHeart />, title: "Création de liens durables", desc: "Amitiés pour toute la vie" }
  ];

  const testimonials = [
    {
      name: "Sarah M.",
      country: "Canada",
      text: "Grâce aux événements d'intégration, j'ai rencontré mes meilleurs amis en France ! L'équipe est vraiment à l'écoute et les activités sont variées.",
      rating: 5,
      city: "Paris"
    },
    {
      name: "Lucas B.",
      country: "Brésil",
      text: "Les ateliers culturels m'ont vraiment aidé à comprendre et apprécier la culture française. Je me sens chez moi maintenant.",
      rating: 5,
      city: "Lyon"
    },
    {
      name: "Amina T.",
      country: "Maroc",
      text: "Le programme de parrainage est exceptionnel ! Mon mentor m'a aidée dans toutes mes démarches et m'a fait découvrir plein d'endroits sympas.",
      rating: 5,
      city: "Marseille"
    }
  ];

  const mentorshipPoints = [
    "Un mentor francophone dédié tout au long de votre séjour",
    "Aide à la découverte de votre nouvelle ville",
    "Conseils pratiques et administratifs personnalisés",
    "Rencontres régulières en présentiel ou en ligne",
    "Accès à un réseau d'entraide et de partage",
    "Événements exclusifs réservés aux binômes"
  ];

  const faqs = [
    {
      q: "Comment puis-je m'inscrire aux événements ?",
      a: "L'inscription se fait directement via notre plateforme en ligne. Vous recevrez une confirmation par email avec tous les détails pratiques. Les événements sont gratuits pour les membres de la communauté."
    },
    {
      q: "Y a-t-il des frais pour participer ?",
      a: "La majorité de nos événements sont gratuits pour les étudiants. Certaines activités comme les voyages ou les dîners peuvent avoir un coût modique pour couvrir les frais d'organisation."
    },
    {
      q: "Puis-je devenir parrain/marraine ?",
      a: "Oui ! Si vous êtes déjà en France depuis quelques mois et que vous maîtrisez bien le français, vous pouvez postuler pour devenir mentor. C'est une belle expérience d'entraide."
    },
    {
      q: "Les événements sont-ils accessibles à tous les niveaux de français ?",
      a: "Absolument ! Nos animateurs sont formés pour s'adapter à tous les niveaux. Nous créons un environnement bienveillant où chacun peut s'exprimer sans pression."
    },
    {
      q: "Puis-je proposer mes propres activités ?",
      a: "Bien sûr ! Nous encourageons les étudiants à proposer leurs idées. Contactez-nous pour devenir animateur bénévole et partager vos passions."
    },
    {
      q: "Y a-t-il des groupes par ville ?",
      a: "Oui, nous avons des communautés dans plus de 20 villes françaises. Chaque ville a son propre programme d'activités adapté à ses spécificités."
    }
  ];

  const stats = [
    { value: "5000+", label: "Étudiants accompagnés" },
    { value: "50+", label: "Événements par an" },
    { value: "20+", label: "Villes participantes" },
    { value: "98%", label: "Taux de satisfaction" }
  ];

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <div className="integration-service-page">
      <Header />
      
      {/* Hero Section with Animated Background */}
      <section className="integration-hero">
        <div className="integration-hero-bg">
          <div className="integration-hero-bg-gradient"></div>
          <div className="integration-hero-bg-particles"></div>
        </div>
        <div className="integration-hero-container">
          <div className="integration-hero-content">
            <div className="integration-badge">
              <FaHeart /> Communauté bienveillante
            </div>
            <h1>Intégration <span className="integration-gradient-text">Sociale</span> en France</h1>
            <p>Créez des liens, partagez des expériences et vivez pleinement votre aventure en France. Rejoignez une communauté de 5000+ étudiants internationaux.</p>
            <div className="integration-hero-actions">
              <Link to="/contact" className="integration-btn-primary">
                <FaRocket /> Rejoindre la communauté
              </Link>
              <Link to="/contact" className="integration-btn-outline">
                <FaSearch /> Découvrir les événements
              </Link>
              <a href="https://wa.me/33695744027" className="integration-btn-whatsapp-hero">
                <FaWhatsapp /> Rejoindre le groupe WhatsApp
              </a>
            </div>
            <div className="integration-hero-stats">
              {stats.map((stat, index) => (
                <React.Fragment key={index}>
                  <div className="integration-stat-item">
                    <strong>{stat.value}</strong>
                    <span>{stat.label}</span>
                  </div>
                  {index < stats.length - 1 && <div className="integration-stat-divider"></div>}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
        <div className="integration-hero-wave">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,154.7C960,171,1056,181,1152,170.7C1248,160,1344,128,1392,112L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>
      </section>

      {/* Events Section */}
      <section className="integration-events">
        <div className="integration-container">
          <div className="integration-section-header">
            <h2>Nos <span className="integration-gradient-text">événements</span></h2>
            <p>Des moments uniques pour créer des souvenirs inoubliables</p>
          </div>
          <div className="integration-events-grid">
            {events.map(event => (
              <div key={event.id} className={`integration-event-card ${event.featured ? 'featured' : ''} ${event.status === 'past' ? 'past-event' : ''}`}>
                {event.featured && (
                  <div className="integration-event-badge">
                    <FaStar /> Événement phare
                  </div>
                )}
                {event.status === 'past' && (
                  <div className="integration-event-status-badge past">
                    <FaClock /> Événement passé
                  </div>
                )}
                <div className="integration-event-icon">{event.icon}</div>
                <h3>{event.title}</h3>
                {event.subtitle && (
                  <p className="integration-event-subtitle">{event.subtitle}</p>
                )}
                <div className="integration-event-date">
                  <FaRegCalendarAlt /> {event.date}
                </div>
                <div className="integration-event-location">
                  <FaMapMarkerAlt /> {event.location}
                </div>
                <div className="integration-event-attendees">
                  <FaUsers /> {event.attendees}
                </div>
                <p className="integration-event-description">{event.description}</p>
                <Link to="/contact" className="integration-event-link">
                  {event.status === 'past' ? 'Voir les photos' : 'Participer'} <FaArrowRight />
                </Link>
              </div>
            ))}
          </div>
          <div className="integration-events-note">
            <p className="integration-note-text">
              <FaRegClock /> Pour le moment, il n'y a pas encore d'événements disponibles. Revenez bientôt pour découvrir nos prochains événements !
            </p>
          </div>
        </div>
      </section>

      {/* Activities Section */}
      <section className="integration-activities">
        <div className="integration-container">
          <div className="integration-section-header">
            <h2>Activités <span className="integration-gradient-text">régulières</span></h2>
            <p>Des activités pour tous les goûts et toutes les passions</p>
          </div>
          <div className="integration-activities-grid">
            {activities.map((activity, index) => (
              <div key={index} className="integration-activity-card">
                <div className="integration-activity-icon" style={{ backgroundColor: `${activity.color}20`, color: activity.color }}>
                  {activity.icon}
                </div>
                <h3>{activity.name}</h3>
                <p>{activity.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mentorship Section */}
      <section className="integration-mentorship">
        <div className="integration-container">
          <div className="integration-mentorship-content">
            <div className="integration-mentorship-text">
              <div className="integration-mentorship-badge">
                <FaHandshake /> Programme exclusif
              </div>
              <h2>Programme de <span className="integration-gradient-text">parrainage</span></h2>
              <p>Bénéficiez d'un accompagnement personnalisé avec notre système de parrainage</p>
              <ul>
                {mentorshipPoints.map((point, index) => (
                  <li key={index}>
                    <FaCheckCircle />
                    <span>{point}</span>
                  </li>
                ))}
              </ul>
              <Link to="/contact" className="integration-mentorship-btn">
                Devenir parrain ou filleul <FaArrowRight />
              </Link>
            </div>
            <div className="integration-mentorship-visual">
              <div className="integration-mentorship-icon">
                <FaHandshake />
              </div>
              <div className="integration-mentorship-stats">
                <div className="integration-mentorship-stat">
                  <strong>500+</strong>
                  <span>Binômes formés</span>
                </div>
                <div className="integration-mentorship-stat">
                  <strong>95%</strong>
                  <span>De satisfaction</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="integration-benefits">
        <div className="integration-container">
          <div className="integration-section-header">
            <h2>Pourquoi rejoindre <span className="integration-gradient-text">notre communauté ?</span></h2>
            <p>Des avantages exclusifs pour une intégration réussie</p>
          </div>
          <div className="integration-benefits-grid">
            {benefits.map((benefit, index) => (
              <div key={index} className="integration-benefit-card">
                <div className="integration-benefit-icon-wrapper">
                  {benefit.icon}
                </div>
                <h4>{benefit.title}</h4>
                <p>{benefit.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="integration-testimonials">
        <div className="integration-container">
          <div className="integration-section-header">
            <h2>Ils ont trouvé <span className="integration-gradient-text">leur famille en France</span></h2>
            <p>Des étudiants satisfaits partagent leur expérience</p>
          </div>
          <div className="integration-testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="integration-testimonial-card">
                <div className="integration-testimonial-header">
                  <div className="integration-testimonial-avatar">
                    <FaRegSmile />
                  </div>
                  <div className="integration-testimonial-rating">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <FaStar key={i} />
                    ))}
                  </div>
                </div>
                <div className="integration-testimonial-quote-icon">
                  <FaQuoteLeft />
                </div>
                <p className="integration-testimonial-quote">"{testimonial.text}"</p>
                <div className="integration-testimonial-author">
                  <h4>{testimonial.name}</h4>
                  <p>{testimonial.country}</p>
                  <div className="integration-testimonial-city">
                    <FaMapMarkerAlt />
                    <span>{testimonial.city}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="integration-partners">
        <div className="integration-container">
          <div className="integration-section-header">
            <h2>Nos <span className="integration-gradient-text">partenaires</span></h2>
            <p>Un réseau d'acteurs engagés pour votre réussite</p>
          </div>
          <div className="integration-partners-grid">
            {partners.map((partner, index) => (
              <div key={index} className="integration-partner-card">
                <div className="integration-partner-icon" style={{ backgroundColor: `${partner.color}15`, color: partner.color }}>
                  {partner.icon}
                </div>
                <h3>{partner.name}</h3>
                <p>{partner.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section with Accordion */}
      <section className="integration-faq">
        <div className="integration-container">
          <div className="integration-section-header">
            <h2>Questions <span className="integration-gradient-text">fréquentes</span></h2>
            <p>Tout ce que vous devez savoir sur notre programme d'intégration</p>
          </div>
          <div className="integration-faq-grid">
            {faqs.map((faq, index) => (
              <div key={index} className="integration-faq-item">
                <button className="integration-faq-question" onClick={() => toggleFaq(index)}>
                  <span>{faq.q}</span>
                  <FaChevronRight className={`integration-faq-icon ${activeFaq === index ? 'rotated' : ''}`} />
                </button>
                <div className={`integration-faq-answer ${activeFaq === index ? 'active' : ''}`}>
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="integration-cta">
        <div className="integration-container">
          <div className="integration-cta-wrapper">
            <div className="integration-cta-content">
              <h2>Rejoignez notre <span className="integration-gradient-text">communauté</span> dès aujourd'hui !</h2>
              <p>Ne restez pas seul, faites partie d'un réseau d'entraide et de partage. Premiers événements offerts !</p>
              <div className="integration-cta-buttons">
                <Link to="/contact" className="integration-btn-cta-primary">
                  <FaRegHeart /> Je veux m'intégrer
                </Link>
                <a href="https://wa.me/33695744027" className="integration-btn-cta-whatsapp">
                  <FaWhatsapp /> Rejoindre le groupe WhatsApp
                </a>
              </div>
              <div className="integration-cta-note">
                <FaGift /> Cadeau de bienvenue offert aux nouveaux membres
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default IntegrationSociale;